import React from 'react';
import { Label } from 'fw/components';
import { Form, TextBox, EmailBox, Switch, PercentageBox } from 'fw/forms';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';
import { PhoneBox } from "areas/shared/controls";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

class CorporateOwnersStaffPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            form: {
                fromSiteReview: false,
                phones: []
            }
        }
    }

    componentDidUpdate() {
        //Add a phone control to be filled
        if (this.state.form.phones.length === 0)
            this.handleAddPhone();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: nextProps.currentCorporateOwner
        });
    }

    save = () => {
        let form = this.state.form;

        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }

        if (!this._form.validate())
            return;

        // Set switch values explicitly as false
        if (form.veteran === null || form.veteran === undefined)
            form.veteran = false;
        if (form.present === null || form.present === undefined)
            form.present = false;
        if (form.id === null || form.id === undefined)
            form.id = false;

        this.setState({ form: form });

        this.props.onSave(this.state.form);
        this.close();
    }

    close = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose();
        });
    }

    onChange = (form) => {
        this.setState({ form });
    }

    handleAddPhone = () => {
        const phones = this.state.form.phones;

        phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -Math.abs(Date.now() | 0)
        });

        this.setState({
            phones
        });
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = "";
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones;

        phones[i] = v;

        this.setState({ form: { ...this.state.form, phones } })
    }

    renderPhones = (readonly) => {
        return this.state.form.phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, i)}
                    disabled={readonly} 
                    required={true}
                    ref={`phone_${i}`} />
                {!readonly && this.state.form.phones.length > 1 &&
                    <Button
                        bsStyle="link"
                        onClick={() => this.handleRemovePhone(i)}><FontAwesomeIcon icon={faTimes} /></Button>
                }
            </div>
        );
    }

    render() {
        let form = this.state.form;
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Corporate Owners</h3>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.onChange}
                        values={this.state.form}
                        ref={(c) => { this._form = c }}>
                        <Row>
                            <Col md={7}>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="firstName" required>First Name</Label>
                                            <TextBox 
                                                name="firstName" 
                                                placeholder="First Name"
                                                required 
                                                maxLength={30} 
                                                readonly={!form.fromSiteReview} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="lastName" required>Last Name</Label>
                                            <TextBox 
                                                name="lastName" 
                                                placeholder="Last Name"
                                                required 
                                                maxLength={30} 
                                                readonly={!form.fromSiteReview} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="title" required>Title</Label>
                                            <TextBox 
                                                name="title"
                                                placeholder="Title" 
                                                required
                                                maxLength={25} 
                                                readonly={!form.fromSiteReview} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label htmlFor="email" required>Email</Label>
                                            <EmailBox 
                                                name="email" 
                                                placeholder="Email" 
                                                required
                                                readonly={!form.fromSiteReview} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        {this.state.form.phones != null && this.state.form.phones.length > 0 &&
                                            <FormGroup>
                                                <Label htmlFor="phoneNumber" required>Phone Number(s)</Label>
                                                {this.renderPhones(!form.fromSiteReview)}
                                            </FormGroup>
                                        }
                                        {this.state.form.phones != null && this.state.form.phones.length < 5 && form.fromSiteReview &&
											<Button type="button" bsStyle="link" onClick={this.handleAddPhone}>
												Add another Phone
											</Button>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={5}>
                                <Row>
                                    <Col md={3}>
                                        <Label htmlFor="veteran" style={{ marginTop: "13px" }}>Veteran</Label>
                                    </Col>
                                    <Col md={9}>
                                        <Switch name="veteran" labelLeft="No" labelRight="Yes" bsStyle="primary" disabled={!form.fromSiteReview || form.order === 0} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Label htmlFor="present" style={{ marginTop: "13px" }}>Present</Label>
                                    </Col>
                                    <Col md={9}>
                                        <Switch name="present" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Label htmlFor="id" style={{ marginTop: "13px" }}>I.D.</Label>
                                    </Col>
                                    <Col md={9}>
                                        <Switch name="id" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label htmlFor="ownerPercent" required>Owner Percent</Label>
                                            <PercentageBox
                                                name='ownerPercent'
                                                placeholder='Owner %'
                                                required
                                                precision={1}
                                                style={{ width: '80px' }}
                                                maxLength='5'
                                                disabled={!form.fromSiteReview}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label htmlFor="votingPercent" required>Voting Percent</Label>
                                            <PercentageBox
                                                name='votingPercent'
                                                placeholder='Voting %'
                                                required
                                                precision={1}
                                                style={{ width: '80px' }}
                                                maxLength='5'
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={this.save}>Save</Button>
                    <Button onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default CorporateOwnersStaffPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/corporateOwners/CorporateOwnersStaffPopUp.js